import { mapGetters } from 'vuex';
import { $WC } from "@/conf/common.const.js"

// 네이버 지도 공유 mixin
export default {
    data() {
        return {
            selectedAddongCd: "",       // 선택된 행정동 코드
            cluster: {
                markerClustering: undefined,
                maxZoom: 20,                    // 클러스터링 할 최대 줌 레벨
                gridSize: 100 * $WC.viewScale,  // 클러스터링 할 범위
                minSize: 2,                     // 클러스터링 할 최소 마커 수
                generator: [10, 100, 200, 500, 1000],   // 클러스터 크기 구간
                clickZoom: true,
                icons: [
                    {
                        content: `<div style="cursor:pointer; width: ${(48 * $WC.viewScale)}px;
                            height: ${(48 * $WC.viewScale)}px; line-height: ${(48 * $WC.viewScale)}px;
                            font-size: ${(10 * $WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$WC.cp}/images/marker2/cluster-marker-1.png);
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(60 * $WC.viewScale)}px;
                            height: ${(60 * $WC.viewScale)}px; line-height: ${(60 * $WC.viewScale)}px;
                            font-size: ${(12 * $WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$WC.cp}/images/marker2/cluster-marker-1.png);
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(72 * $WC.viewScale)}px;
                            height: ${(72 * $WC.viewScale)}px; line-height: ${(72 * $WC.viewScale)}px;
                            font-size: ${(14 * $WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$WC.cp}/images/marker2/cluster-marker-1.png);
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(84 * $WC.viewScale)}px;
                            height: ${(84 * $WC.viewScale)}px; line-height: ${(84 * $WC.viewScale)}px;
                            font-size: ${(16 * $WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$WC.cp}/images/marker2/cluster-marker-1.png);
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(96 * $WC.viewScale)}px;
                            height: ${(96 * $WC.viewScale)}px; line-height: ${(96 * $WC.viewScale)}px;
                            font-size: ${(18 * $WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$WC.cp}/images/marker2/cluster-marker-1.png);
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                ],
            },
        }
    },
    computed: {
        ...mapGetters({
            naverMaps: 'getNaverMaps',
            geoJsonDrawing: 'getGeoJsonDrawing',
            markerMap: 'getMarkerMap',
            selectedMarker: 'getSelectedMarker',
            curInfoWindow: 'getCurInfoWindow',
            polylineMap: 'polylineMap',
            circleMap: 'getCircleMap',
        }),
    },
    methods: {
        // 해당 행정동 선택
        selectAddong(admCode) {
            this.geoJsonDrawing.setOptionAll('strokeColor', '#ffffff');
            this.geoJsonDrawing.setOptionAll('strokeWeight', 2);
            this.geoJsonDrawing.setZIndexAll(0);

            this.geoJsonDrawing.setOption(admCode, 'strokeColor', '#000000');
            this.geoJsonDrawing.setOption(admCode, 'strokeWeight', 4);
            this.geoJsonDrawing.setZIndex(admCode, 100);

            this.selectedAddongCd = admCode;
        },
        noneSelectAddong() {
            this.geoJsonDrawing.setOptionAll('strokeColor', '#ffffff');
            this.geoJsonDrawing.setOptionAll('strokeWeight', 2);
            this.geoJsonDrawing.setZIndexAll(0);

            this.selectedAddongCd = "";
        },

        // 해당 키의 마커목록 존재 여부
        hasMarkers(key) {
            return (typeof this.markerMap[key] !== 'undefined' && this.markerMap[key].length > 0);
        },
        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showMarkers(key, isShow) {
            if(this.hasMarkers(key)) {
                this.markerMap[key].forEach(marker => {
                    if(isShow) {
                        marker.setMap(this.naverMaps);
                    } else {
                        if(typeof marker.infoWindow !== 'undefined') {
                            this.closeInfoWin(marker.infoWindow);
                        }
                        marker.setMap(null);
                    }
                });
            }
        },
        showClusterMarkers (key, isShow) {
            if(this.hasMarkers(key)) {
                if(!isShow) {
                    this.cluster.markerClustering.setMap(null);
                } else {
                    this.cluster.markerClustering = new MarkerClustering({
                            minClusterSize: this.cluster.minSize,
                            maxZoom: this.cluster.maxZoom,
                            map: this.naverMaps,
                            markers: this.markerMap[key],
                            disableClickZoom: !this.cluster.clickZoom,
                            gridSize: this.cluster.gridSize,
                            icons: this.cluster.icons,
                            indexGenerator: this.cluster.generator,
                            stylingFunction: (clusterMarker, count) => {
                                jQuery(clusterMarker.getElement()).find('div:first-child').text(count);
                            }
                    });
                }
            }
        },

        // 마커 생성
        makeMarker(key, data, clickMarkerHandle, imgFileNm, imgPath, w, h) {
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }

            if(typeof imgPath === 'undefined') {
                imgPath = '/images/marker/';
            }

            if(typeof w === 'undefined') {
                w = 32;
            }

            if(typeof h === 'undefined') {
                h = 40;
            }

            // 마커 크기 조정 (화면배율)
            w = w * ($WC.viewScale <= 1 ? (1/2) : $WC.viewScale / 2);
            h = h * ($WC.viewScale <= 1 ? (1/2)  : $WC.viewScale / 2);

            let marker = new naver.maps.Marker({
                position: new naver.maps.LatLng(data.lttdVal, data.lgtdVal),
                icon: {
                    url: $WC.cp + imgPath + imgFileNm,
                    size: new naver.maps.Size(w, h),
                    origin: new naver.maps.Point(0, 0),
                    anchor: new naver.maps.Point((w / 2), h),
                    scaledSize: new naver.maps.Size(w, h)
                }
            });

            // 데이터 연결
            marker.data = data;

            if(typeof clickMarkerHandle === 'function') {
                naver.maps.Event.addListener(marker, 'click', event => {
                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                    clickMarkerHandle(event, data, marker);
                });
            }
            this.markerMap[key].push(marker);

            return marker;
        },

        addClickMarkerListener(key, clickMarkerHandle, imgFileNm, imgPath, w, h) {
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }

            naver.maps.Event.addListener(this.naverMaps, 'click', event => {
                let clickEvent = event;
                this.showMarkers(key, false);
                let point = event.coord;
                let marker = new naver.maps.Marker({
                    map: this.naverMaps,
                    position: point,
                    icon: {
                        url: $WC.cp + imgPath + imgFileNm,
                        size: new naver.maps.Size(w, h),
                        origin: new naver.maps.Point(0, 0),
                    }
                });

                if(typeof clickMarkerHandle === 'function') {
                    naver.maps.Event.addListener(marker, 'click', event => {
                        this.$store.dispatch("SET_SELECTED_MARKER", marker);
                        clickMarkerHandle(clickEvent, event, marker);
                    });

                    naver.maps.Event.trigger(marker, 'click', null);
                }
                this.markerMap[key].push(marker);
            });
        },

        addMarker(key, marker) {
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }

            this.markerMap[key].push(marker);
        },

        removeMarker(key) {
            if(this.hasMarkers(key)) {
                this.showMarkers(key, false);
                delete this.markerMap[key];
            }
        },

        removeAllMarker() {
            let markerMap = this.markerMap;

            for(let key in markerMap) {
                this.removeMarker(key);
            }
        },

        disableAllMarker() {
            let markerMap = this.markerMap;

            for(let key in markerMap) {
                this.showMarkers(key, false);
            }
        },

        hasPolylines(key) {
            return (typeof this.polylineMap[key] !== 'undefined' && this.polylineMap[key].length > 0);
        },

        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showPolylines(key, isShow) {
            if(this.hasPolylines(key)) {
                this.polylineMap[key].forEach(polyline => {
                    if(isShow) {
                        polyline.setMap(this.naverMaps);
                    } else {
                        polyline.setMap(null);
                    }
                });
            }
        },

        // 폴리라인이 파일인 경우
        makePolyline(key, geoJsonUrl, strokeColor, strokeWeight, isShow, strokeStyle, clickHandle) {
            if(typeof this.polylineMap[key] === 'undefined') {
                this.polylineMap[key] = [];
            }
            axios.get(geoJsonUrl).then(res => {
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));
                let newFeatures = geoJson.features;

                newFeatures.map((currVal, idx, arr) => {
                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach(paths => {
                        if(paths.length == 1) {
                            paths = paths[0];
                        }
                        this.drawPolyline(key, paths, strokeColor, strokeWeight, isShow, strokeStyle, clickHandle);
                    });
                });
            });
        },

        // 폴리라인이 아이디로 구분된 경우
        makeIdPolyline(keyNm, geoJsonUrl, strokeColor, strokeWeight) {
            axios.get($WC.cp + "geojson/" + geoJsonUrl).then(res => {
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));
                let newFeatures;
                if(typeof this.filterFun !== 'undefined') {
                    newFeatures = geoJson.features.filter(this.filterFun);
                } else {
                    newFeatures = geoJson.features;
                }

                newFeatures.map((currVal, idx, arr) => {
                    let prop = currVal.properties;
                    let key = prop[keyNm];

                    if(typeof this.polylineMap[key] === 'undefined') {
                        this.polylineMap[key] = [];
                    }

                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach(paths => {
                        if(paths.length == 1) {
                            paths = paths[0];
                        }
                        this.drawPolyline(key, paths, strokeColor, strokeWeight);
                    });
                });
            });
        },

        drawPolyline(key, paths, strokeColor, strokeWeight, isShow, strokeStyle, clickHandle) {
            if(typeof strokeStyle === 'undefined') {
                strokeStyle = 'solid';
            }


            let polyline = new naver.maps.Polyline({
                path: paths,
                strokeColor: strokeColor,
                strokeOpacity: 0.6,
                strokeWeight: Math.ceil(strokeWeight * $WC.viewScale),
                strokeStyle: strokeStyle,
            });

            if(typeof clickHandle === 'function') {
                polyline.setClickable(true);
                naver.maps.Event.addListener(polyline, 'click', event => {
                    clickHandle(event);
                });

                //naver.maps.Event.trigger(marker, 'click', null);
            }

            this.polylineMap[key].push(polyline);
            if(isShow) {
                polyline.setMap(this.naverMaps);
            }
        },

        removePolyline(key) {
            if(this.hasPolylines(key)) {
                this.showPolylines(key, false);
                delete this.polylineMap[key];
            }
        },

        setPolylineStrokeColor(key, strokeColor) {
            if(this.hasPolylines(key)) {
                this.polylineMap[key].forEach(polyline => {
                    polyline.setOptions("strokeColor", strokeColor);
                });
            }
        },

        disableAllPolyline() {
            let polylineMap = this.polylineMap;
            for(let key in polylineMap) {
                this.showPolylines(key, false);
            }
        },

        // 해당 키의 서클 목록 존재 여부
        hasCircles(key) {
            return (typeof this.circleMap[key] !== 'undefined' && this.circleMap[key].length > 0);
        },

        // 해당 키의 서클 목록을 지도에 보여주거나 감춘다.
        showCircles(key, isShow) {
            if(this.hasCircles(key)) {
                this.circleMap[key].forEach(circle => {
                    if(isShow) {
                        circle.setMap(this.naverMaps);
                    } else {
                        circle.setMap(null);
                    }
                });
            }
        },

        // 반경 표시
        makeCircle(key, lttdVal, lgtdVal, radius, fillColor, fillOpacity, isShow) {
            if(typeof this.circleMap[key] === 'undefined') {
                this.circleMap[key] = [];
            }
            let position = new naver.maps.LatLng(lttdVal, lgtdVal);
            this.drawCircle(key, position, radius, fillColor, fillOpacity, isShow);
        },

        drawCircle(key, position, radius, fillColor, fillOpacity, isShow) {
            let circle = new naver.maps.Circle({
                center: position,
                radius: radius,
                fillColor: fillColor,
                fillOpacity: fillOpacity,
                strokeColor: fillColor,
                strokeWeight: 1,
            });

            this.circleMap[key].push(circle);
            if(isShow) {
                circle.setMap(this.naverMaps);
            }
        },

        removeCircle(key) {
            if(this.hasCircles(key)) {
                this.showCircles(key, false);
                delete this.circleMap[key];
            }
        },

        disableCircle(key) {
            if(this.hasCircles(key)) {
                this.showCircles(key, false);
            }
        },

        disableAllCircle() {
            let circleMap = this.circleMap;
            for(var key in circleMap) {
                this.showCircles(key, false);
            }
        },

        openInfoWin(content) {
            let infoWindow = new naver.maps.InfoWindow({
                content: content
            });

            infoWindow.open(this.naverMaps, this.selectedMarker);

            infoWindow.contentElement.querySelectorAll('a.self-close-btn').forEach(el => {
                el.addEventListener('click', event => {
                    event.preventDefault();
                    this.closeInfoWin(infoWindow);
                })
            });

            this.$store.dispatch("SET_CUR_INFO_WINDOW", infoWindow);
            return infoWindow;
        },

        openInfoWinAt(content, lat, lng) {
            var infoWindow = new naver.maps.InfoWindow({
                content: content
            });
            var position = naver.maps. LatLng(lat, lng);
            infoWindow.setPosition(position);
            infoWindow.open(this.naverMaps);

            infoWindow.contentElement.querySelectorAll('a.self-close-btn').forEach(el => {
                el.addEventListener('click', event => {
                    event.preventDefault();
                    this.closeInfoWin(infoWindow);
                })
            });

            this.selectedMarker.infoWindow = infoWindow;
            this.$store.dispatch("SET_CUR_INFO_WINDOW", infoWindow);

            return infoWindow;
        },

        closeInfoWin(infoWindow) {
            let closeInfoWindow = infoWindow || this.curInfoWindow;
            if(closeInfoWindow != undefined) {
                closeInfoWindow.close();
            }

            if(closeInfoWindow === this.curInfoWindow) {
                this.$store.dispatch("SET_CUR_INFO_WINDOW", undefined);
            }

        },
    },
}
